import { render, staticRenderFns } from "./OverdueInvoiceList.vue?vue&type=template&id=02c922fd&scoped=true&"
import script from "./OverdueInvoiceList.vue?vue&type=script&lang=ts&"
export * from "./OverdueInvoiceList.vue?vue&type=script&lang=ts&"
import style0 from "./OverdueInvoiceList.vue?vue&type=style&index=0&id=02c922fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c922fd",
  null
  
)

export default component.exports